// extracted by mini-css-extract-plugin
export default {"Actions":"RecoveryPasswordFirstStepForm_Actions__1uEsJ","Actions__item":"RecoveryPasswordFirstStepForm_Actions__item__3sRlB"};